export default __webpack_public_path__ + "static/13-304029d23df24e5e78d4a87792801c52.jpg";